export default {
	required: v => (!!v && !!v.length) || 'Tämä tieto on pakollinen.',
	email: v => /.+@.+/.test(v) || 'Tarkista sähköpostiosoitteen muotoilu.',
	sum: v => (!v || /^\d*(.\d{1,2})?$/.test(parseFloat(v))) || 'Tarkista arvon muotoilu.',
}
